import { url } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class LegacyIsPostcodeDeliverable {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * LegacyIsPostcodeDeliverable constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Check if the postcode is deliverable.
     *
     * @param {String} postcode
     *
     * @returns {Boolean}
     */
    async handle(postcode) {
        let apiUrl = url(ApiEndpoints['postcodes.deliverable'], [postcode]);
        let request = await this.apiService
            .get(apiUrl)
            .catch(() => false);

        return request.status === 200;
    }
}
